import { render } from "./GrattersCreateComponent.vue?vue&type=template&id=5269236e&scoped=true"
import script from "./GrattersCreateComponent.vue?vue&type=script&lang=js"
export * from "./GrattersCreateComponent.vue?vue&type=script&lang=js"

import "./GrattersCreateComponent.vue?vue&type=style&index=0&id=5269236e&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5269236e"]])

export default __exports__